import { GraphQLClient, request } from 'graphql-request'
import { useAuth } from 'use-auth0-hooks'
import constants from './constants'

export const API = process.env.NEXT_PUBLIC_APP_NASDB_URL

export const fetcher = (query, ...args) => {
  return request(API, query, ...args)
}

export const useFetchWithToken = () => {
  const { token } = useAuth({
    audience: `default`,
    scope: 'openid profile email offline_access',
  })

  const graphQLClient = new GraphQLClient(API, {
    headers: {
      Authorization: token ? `Bearer ${token.idToken}` : null,
    },
  })
  return { fetcher: graphQLClient, token }
}
